// Import of the module

import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";

// Import select options from the filter file
import { fieldKeyOptions } from "./filter";

// Type of the fields in the table

export type A3Metadata = {
  id: number;
  owner_type: string;
  owner_id: number;
  field_key: string;
  field_value: string;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const a3_metadata_columns: ColumnDef<A3Metadata>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t("a3_metadata.columns.id", {
        ns: "tables",
        defaultValue: "ID",
      }),
  },
  {
    accessorKey: "owner_type",
    header: () =>
      i18n.t("a3_metadata.columns.owner_type", {
        ns: "tables",
        defaultValue: "Owner Type",
      }),
  },
  {
    accessorKey: "owner_id",
    header: () =>
      i18n.t("a3_metadata.columns.owner_id", {
        ns: "tables",
        defaultValue: "Owner ID",
      }),
  },
  {
    accessorKey: "field_key",
    header: () =>
      i18n.t("a3_metadata.columns.field_key", {
        ns: "tables",
        defaultValue: "Field Key",
      }),
    cell: ({ getValue }) => {
      const value = getValue() as string;
      const option = fieldKeyOptions.find((opt) => opt.value === value);
      return option ? option.label : value;
    },
  },
  {
    accessorKey: "field_value",
    header: () =>
      i18n.t("a3_metadata.columns.field_value", {
        ns: "tables",
        defaultValue: "Field Value",
      }),
  },
  {
    id: "actions",
    header: () => (
      <div className="text-right">
        {i18n.t("a3_metadata.columns.actions", {
          ns: "tables",
          defaultValue: "Actions",
        })}
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
